import type { DocumentSourceDto } from '@dbrain/shared';
import { useTranslation } from 'react-i18next';
import { MicrosoftIcon } from '../MicrosoftIcon.js';
import { SourceTile } from './icons.js';
import { sourceLabel, sourcePath } from './model.js';

/**
 * Where a document came from (MsBelgelerKaynak's "Kaynak"): "SharePoint · Finans", "OneDrive", "Outlook eki" with
 * Microsoft's own icon of the source right before its name, or a quiet "Bilgisayardan" for an upload. Names only,
 * never a link.
 */
export function SourceLabel({ source, quietUpload = true }: { source: DocumentSourceDto | null | undefined; quietUpload?: boolean }) {
  const { t } = useTranslation();
  const text = sourceLabel(source, t);
  if (!source) {
    return quietUpload ? (
      <span className="m365-source m365-source--upload" data-testid="doc-source" data-source="upload">
        {text}
      </span>
    ) : null;
  }
  return (
    <span className="m365-source" title={text} data-testid="doc-source" data-source={source.provider}>
      <MicrosoftIcon product={source.provider} size={16} />
      <span className="m365-source__text">{text}</span>
    </span>
  );
}

/** The aside's box: "Kaynak" over the path as names ("SharePoint › Finans › Belgeler"). */
export function SourceBox({ source }: { source: DocumentSourceDto }) {
  const { t } = useTranslation();
  return (
    <div className="m365-source-box" data-testid="doc-source-box" data-source={source.provider}>
      <SourceTile source={source.provider} size="md" />
      <span className="m365-source-box__text">
        <span className="m365-source-box__label">{t('documents.source.box')}</span>
        <span className="m365-source-box__path">{sourcePath(source, t)}</span>
      </span>
    </div>
  );
}
